import { Enum_Question_Type, Enum_Questiontree_Treetype } from '@cyren/common-lib';
import { TQuestionInput } from '../graphql-enhanced';
import { QuestionTreeType, QuestionType } from '../patient/patient-types';

// Auto-generated third-party tree and question key constants
export const THIRD_PARTY_TREE_KEY = 'patient-self-guardian';
export const THIRD_PARTY_QUESTION_KEY = 'q-patient-self';
export const THIRD_PARTY_OPTION_MYSELF = 'o-myself';
export const THIRD_PARTY_OPTION_SOMEONE_ELSE = 'o-someone-else';

/**
 * Creates the auto-generated third-party tree (step) that contains
 * the third-party question.
 */
export const createThirdPartyTree = (): QuestionTreeType => ({
  treeKey: THIRD_PARTY_TREE_KEY,
  treeType: Enum_Questiontree_Treetype.Step,
  entryQuestionKeys: [THIRD_PARTY_QUESTION_KEY],
  step: 0,
});

/**
 * Creates the auto-generated third-party question that asks
 * "Are you answering for yourself or someone else?"
 *
 * This question should be injected as the first question when
 * enableThirdParty is enabled on the survey.
 */
export const createThirdPartyQuestion = (): QuestionType => ({
  questionKey: THIRD_PARTY_QUESTION_KEY,
  type: Enum_Question_Type.Select,
  answerKeys: [THIRD_PARTY_OPTION_MYSELF, THIRD_PARTY_OPTION_SOMEONE_ELSE],
  required: true,
  typeOptions: {
    min: '1',
    max: '1',
    multi: false,
  },
} as QuestionType);

/**
 * Creates the third-party question input for editing purposes.
 */
export const createThirdPartyQuestionInput = (): TQuestionInput => ({
  questionKey: THIRD_PARTY_QUESTION_KEY,
  type: Enum_Question_Type.Select,
  answerKeys: [THIRD_PARTY_OPTION_MYSELF, THIRD_PARTY_OPTION_SOMEONE_ELSE],
  required: true,
  typeOptions: {
    min: '1',
    max: '1',
    multi: false,
  },
});

/**
 * Translations for the third-party question
 * These should be added to the translation system
 */
export const thirdPartyQuestionTranslations: Record<string, Record<string, string>> = {
  [THIRD_PARTY_QUESTION_KEY]: {
    en: 'Are you answering for yourself or someone else?',
    ko: '본인을 위해 답변하시나요, 아니면 다른 분을 위해 답변하시나요?',
    ja: 'ご自身のことについて回答されていますか、それとも他の方のことについて回答されていますか?',
    es: '¿Está respondiendo por usted mismo o por otra persona?',
  },
  [THIRD_PARTY_OPTION_MYSELF]: {
    en: 'Myself',
    ko: '본인',
    ja: '自分自身',
    es: 'Yo mismo',
  },
  [THIRD_PARTY_OPTION_SOMEONE_ELSE]: {
    en: 'Someone else',
    ko: '다른 사람',
    ja: '他の方',
    es: 'Otra persona',
  },
};
